import {get} from 'lodash';
import isNumeric from 'is-number';

import {ProbeProcessor} from '../types';

export const getMinMax = (processor: ProbeProcessor, item) => {
  let min = get(processor, ['properties', 'range', 'min']);
  let max = get(processor, ['properties', 'range', 'max']);
  min = isNumeric(min) ? Number(min) : item.properties.range_min;
  max = isNumeric(max) ? Number(max) : item.properties.range_max;
  return {min, max};
};
